export default "__VITE_ASSET__vUs3WdsX__"